const footerListData = [
	{ _id: "footerList1", link: "", name: "Home" },
	{ _id: "footerList2", link: "movies", name: "Movies" },
	{ _id: "footerList3", link: "tvShows", name: "TV Shows" },
	{ _id: "footerList4", link: "favorites", name: "Favorites" },
	{ _id: "footerList5", link: "about", name: "About" },
	{ _id: "footerList6", link: "contact", name: "Contact Us" },
];

export default footerListData;
